import React from 'react'

import {
  AppearingWrapper,
  CTAHeadline,
  CTAParagraph,
  SectionContainer,
} from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button, Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import Roadmap from './Roadmap'

type Props = {
  onAction?: () => void
}

function HowItWorksSection({ onAction }: Props) {
  return (
    <SectionContainer px={LANDING_CONTENT_PX} py={[48, 48, 64]}>
      <AppearingWrapper centered>
        <Column alignCenter fullWidth>
          <Column
            alignCenter
            fullWidth
            gap={10}
            maxWidth={LANDING_CONTENT_WIDTH_PX}
            mb={64}
          >
            <SubsectionTitle
              centered
              maxWidth={800}
              paragraph={
                <>
                  With Emajin Golf, you’ll discover a rewarding way to connect
                  with your peers and business colleagues that’s unlike anything
                  else.
                </>
              }
              subtitle="Network like never before – both on and off the golf course."
              title="How It Works"
            />

            <CTAParagraph centered text="It’s also so simple." />
          </Column>

          <Roadmap />

          <Column alignCenter gap={9} mt={64}>
            <CTAHeadline
              centered
              text="Join us today and experience it for yourself."
            />

            <Button large onClick={onAction}>
              Join Us Today
            </Button>
          </Column>
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default HowItWorksSection
